import { patchState, signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { ErrorResponse } from '@core/models';
import { inject } from '@angular/core';
import { PornRepository } from '@core/repositories/porn.repository';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { debounceTime, distinctUntilChanged, pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';

type TagState = {
  list: Array<string> | null;
  isLoading: boolean;
  error: ErrorResponse | null;
};

const initialTagState: TagState = {
  list: null,
  isLoading: false,
  error: null,
};

export const TagStore = signalStore(
  { providedIn: 'root' },
  withState(initialTagState),
  withMethods((state, api = inject(PornRepository)) => ({
    load: rxMethod<void>(
      pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => patchState(state, { isLoading: true })),
        switchMap(() => {
          return api.getTags().pipe(
            tapResponse({
              next: (feed) => patchState(state, { list: feed.data }),
              error: () => {},
              finalize: () => patchState(state, { isLoading: false }),
            }),
          );
        }),
      ),
    ),
  })),
  withHooks((store) => ({
    onInit() {
      store.load();
    },
  })),
);